import { render, staticRenderFns } from "./PagePerformanceReview.vue?vue&type=template&id=35fcd56a&"
import script from "./PagePerformanceReview.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReview.vue?vue&type=script&lang=js&"
import style0 from "./PagePerformanceReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports